// extracted by mini-css-extract-plugin
module.exports = {"reportParagraphTitle":"ReportStyles_reportParagraphTitle__nJt7Z","reportCart":"ReportStyles_reportCart__1Up1A"};